<template>
  <div class="hot_view_box_skeleton">
    <ul class="l_ul_skeleton">
      <li class="l_li_skeleton" v-for="(item, index) in 10" :key="item">
          <!-- <div class="li_cont_skeleton"></div> -->
          <div class="li_cont_skeleton" @click.stop="itemClick(item, index)">
            <span class="qh_box"> {{ digit + index + 1 }}</span>
            <p>-</p>
            <!-- <icon-fire v-show="(digit + index) < hotNum" class="qh_box icon_img" /> -->
          </div>
      </li>
    </ul>
  </div>
</template>
<script setup>
const props = defineProps({
  title: {
    type: String,
    default: ""
  },
  hotNum: {
    type: Number,
    default: 0
  },
  hostSeaList: {
    type: Array,
    default: () => []
  },
  currentPage: {
    default: 1
  }
})

const digit = computed(() => (props.currentPage * 20))
const emit = defineEmits(['hotItemClick'])


const itemClick = (item, index) => {
  emit("hotItemClick", [item, index])
}


</script>

<style scoped lang="scss">
.hot_view_box_skeleton {
  width: 100%;
  height: auto;
  background: rgba(216, 216, 216, 0);

  .h_title {
    font-weight: bold;
    font-size: 34px;
    color: #000000;
    line-height: 29px;
    text-align: center;
    font-style: normal;
    margin-bottom: 30px;
  }

  .l_ul_skeleton {
    width: 100%;
    height: auto;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 8px;

    .l_li_skeleton {
      width: 100%;
      height: 55px;
      padding: 0 40px;
      background: transparent;
      border-radius: 0;
      cursor: pointer;
      &:nth-last-child(1) {
        .li_cont_skeleton {
          border-bottom: none;
        }
      }
      .li_cont_skeleton {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        font-style: normal;
        // background-image: linear-gradient(0deg, rgba(0, 0, 0, .38) 0, rgba(0, 0, 0, .2) 40%, rgba(0, 0, 0, .14) 60%, rgba(0, 0, 0, .1) 80%);
        // background: linear-gradient(to right, #f5f8ff 19%, #ffffff 54%, #f5f8ff 86%);
        // background-size: 400% 100%;
        // animation: skeleton-loading 2s ease infinite;


        .qh_box {
          height: 22px;
        }

        span {
          color: #E0E0E1;
          text-align: left;
          display: inline-block;
          height: 22px;
        }

        p {
          color: #1D1D20;
          text-align: center;
          width: max-content;
          max-width: 90%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin: 0 auto;
        }

        .icon_img {}
      }

      @keyframes skeleton-loading {
        0% {
          background-position: 100% 50%;
        }
        100% {
          background-position: 0 50%;
        }
      }

    }

    .l_li_check {
      background: #F4F5F6;
      border-radius: 0;
    }

    .l_li:first-child {
      border-radius: 8px 8px 0px 0px;
    }

    .l_li:last-child {
      border-radius: 0px 0px 8px 8px;

      .li_cont {
        border-bottom: 1px solid transparent;
      }
    }
  }
}

@media (any-hover: hover) {
  .hot_view_box .l_ul .l_li:hover {
    background: #F4F5F6;
  }
}

@media screen and (max-width: 854px) {
  .hot_view_box {
    .h_title {
      font-weight: 600;
      font-size: 20px;
      line-height: 24px;
      margin-bottom: 10px;
    }

    .l_ul {
      .l_li {
        height: 51px;
        padding: 0 20px;

        .li_cont {
          font-weight: 500;
          font-size: 16px;
          line-height: 19px;

          .qh_box {
            height: 19px;
          }

          p {
            margin-left: 5px;
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
